export default __webpack_public_path__ + "static/media/VN.e87ca22a.svg";